// extracted by mini-css-extract-plugin
export var textareaContainer = "Textarea-module--textareaContainer--2NRWf";
export var textareaRoot = "Textarea-module--textareaRoot--hg-Ww";
export var labelRoot = "Textarea-module--labelRoot--u8a6u";